import { render, staticRenderFns } from "./wxcode.vue?vue&type=template&id=3f6c7bd9"
import script from "./wxcode.vue?vue&type=script&lang=js"
export * from "./wxcode.vue?vue&type=script&lang=js"
import style0 from "./wxcode.vue?vue&type=style&index=0&id=3f6c7bd9&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports